import { inject, Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { MemberBackend } from "src/app/backend/api/member.backend";
import { MemberLight } from "src/app/backend/models/member/member";
import { appState } from "src/app/core/state";

@Injectable({
  providedIn: "root"
})
export class MemberBootstrapCacheService {
  readonly #memberBackend = inject(MemberBackend);
  #listActiveAllLightPromise: Promise<MemberLight[]> | null = null;
  #cachedTenantId: string | undefined;

  loadActiveAllLight(): Promise<MemberLight[]> {
    const tenantId: string | undefined = appState.tenantId;

    if (this.#listActiveAllLightPromise && this.#cachedTenantId === tenantId) {
      return this.#listActiveAllLightPromise;
    }

    this.#cachedTenantId = tenantId;
    this.#listActiveAllLightPromise = lastValueFrom(
      this.#memberBackend.listActiveAllLight(false, tenantId)
    );

    return this.#listActiveAllLightPromise;
  }

  invalidate(): void {
    this.#listActiveAllLightPromise = null;
    this.#cachedTenantId = undefined;
  }
}
